import * as API from '@siloreal:shared:api';

const SILOBAG_EXTRACTION_LIST_ENDPOINT = '/silobag_extraction';

export type SilobagExtractionListQuery = {
  organization_id?: number;
};

export type SilobagExtractionListServiceContract = {
  query: SilobagExtractionListQuery;
  signal?: AbortSignal;
};

export async function listSilobagExtractionsService(
  contract: SilobagExtractionListServiceContract
): Promise<SilobagExtractionListResponse> {
  const { data } = await API.http.fetch.get<SilobagExtractionListResponse>(SILOBAG_EXTRACTION_LIST_ENDPOINT, {
    query: buildSilobagExtractionListQuery(contract.query),
    signal: contract.signal,
  });

  return data;
}

export function buildSilobagExtractionListQuery(query: SilobagExtractionListQuery): string {
  const queryParameters = new URLSearchParams();

  if (query.organization_id !== undefined) {
    queryParameters.set('organization_id', String(query.organization_id));
  }
  const queryString = queryParameters.toString();

  return queryString ? `?${queryString}` : '';
}

export type SilobagExtractionListResponse = SilobagExtractionListItem[];

export type SilobagExtractionListItem = {
  driver: string | null;
  freight_transport: string | null;
  carrier: string | null;
  back_plate: string | null;
  trailer_back_plate: string | null;
  ctg_document: string | null;
  contract: string | null;
  waybill: string | null;
  destination: string | null;
  gross_weight: string | number | null;
  weight: string | number | null;
  truck_weight: string | number | null;
  observations: string | null;
  extraction_date: Date | string;
  users: {
    fullname: string;
  };
  silobags: {
    id: string;
    name: string;
    initial_humidity: string | null;
    active: boolean;
    silobag_data_status_id: number;
    silobag_species_types: {
      silobag_species_types_translations: Array<{
        id: number;
        language_id: number;
        description: string;
        silobag_specie_type_id: number;
      }>;
    };
    lots: {
      name: string;
    };
    silobags_origin_lots: Array<{
      lots: {
        name: string;
      } | null;
    }>;
    countrysides: {
      name: string;
      countryside_zone: {
        name: string;
      } | null;
    };
    organizations: {
      name: string;
    };
  };
};
